import config from '../config';

// ✅ Get all sensors
export const getAllSensors = async () => {
  const resp = await fetch(`${config.apiUrl}/api/sensors`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch sensors');
  return data;
};

// ✅ Get single sensor by its ID
export const getSensorById = async (sensorId) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors/${sensorId}`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch sensor');
  return data;
};

// ✅ Get all sensors tied to a specific MCU
export const getSensorsByMCU = async (mcuId) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors/mcu/${mcuId}`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch sensors for MCU');
  return data;
};
// ✅ scan  sensors by mac
export const scanSensorsByMAC = async (mac) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors/scan-mac/${encodeURIComponent(mac)}`);
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to fetch sensors for MCU');
  return data;
};

// ✅ Create a new sensor
export const createSensor = async (sensorInfo) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(sensorInfo),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to create sensor');
  return data;
};

// ✅ Update an existing sensor
export const updateSensor = async (sensorId, sensorInfo) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors/${sensorId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(sensorInfo),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to update sensor');
  return data;
};

// ✅ Delete a sensor
export const deleteSensor = async (sensorId) => {
  const resp = await fetch(`${config.apiUrl}/api/sensors/${sensorId}`, {
    method: 'DELETE',
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.message || 'Failed to delete sensor');
  return data;
};
